export var InspectDataTab;
(function (InspectDataTab) {
    InspectDataTab["ActualsAndProjections"] = "ActualsAndProjections";
    InspectDataTab["Asset"] = "Asset";
    InspectDataTab["Cashflows"] = "Cashflows";
    InspectDataTab["CommitmentPacingOutputs"] = "CommitmentPacingOutputs";
    InspectDataTab["Fund"] = "Fund";
    InspectDataTab["FullHistory"] = "FullHistory";
    InspectDataTab["Portfolio"] = "Portfolio";
})(InspectDataTab || (InspectDataTab = {}));
export var InspectDataComparisonTab;
(function (InspectDataComparisonTab) {
    InspectDataComparisonTab["MainPortfolio"] = "MainPortfolio";
    InspectDataComparisonTab["ComparatePortfolio"] = "ComparatePortfolio";
})(InspectDataComparisonTab || (InspectDataComparisonTab = {}));
